import { getFeatureAllDocuments } from 'reactApp/modules/features/features.selectors';
import { store } from 'reactApp/store';

/**
 * По расширению файла определяем возможность отображения его в разделе документов.
 */
export const getAvailableSectionInAllDocuments = (extension: string) => {
    const state = store.getState();
    const feature = getFeatureAllDocuments(state);

    for (const section in feature) {
        if (feature[section].includes(extension)) {
            return section;
        }
    }

    return null;
};

export const isAvailableInDocumentSection = (extension: string) => {
    const state = store.getState();
    const feature = getFeatureAllDocuments(state);

    return feature.document.includes(extension);
};
